import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshancab() {



  const cardData = {
"keyword": "Ashtavinayak Darshan Cab from Pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Ashtavinayak Darshan Cab from Pune for devotees seeking a peaceful, safe, and well-organized pilgrimage experience. Whether you are planning a one-day express tour, 2-day darshan trip, family pilgrimage, senior citizen-friendly journey, or group spiritual tour, our cab service ensures a smooth and stress-free travel experience across all eight sacred Ganpati temples. With experienced drivers who are familiar with temple routes and rural Maharashtra roads, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for individuals, families, and large groups. With flexible itinerary options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and divine Ashtavinayak pilgrimage journey.",

"topPlaces": [
  {
    "title": "Morgaon Mayureshwar Ganpati",
    "description":
      "Morgaon Mayureshwar is the first temple in the Ashtavinayak circuit and is dedicated to Lord Ganesha in his Mayureshwar form. It is a highly sacred and important pilgrimage site known for its beautiful temple architecture and spiritual significance."
  },
  {
    "title": "Siddhatek Siddhivinayak",
    "description":
      "Siddhatek Siddhivinayak Temple is located on the banks of the Bhima River and is known for its peaceful environment and spiritual importance. Devotees often visit this temple after Morgaon during the Ashtavinayak yatra."
  },
  {
    "title": "Pali Ballaleshwar",
    "description":
      "Pali Ballaleshwar is a unique Ashtavinayak temple known for being the only Ganpati idol named after a devotee. Surrounded by scenic hills, it offers a calm and devotional atmosphere."
  },
  {
    "title": "Mahad Varadvinayak",
    "description":
      "Mahad Varadvinayak Temple is a serene and ancient shrine located near Khalapur. It is known for its peaceful surroundings and the belief that Lord Ganesha fulfills devotees’ wishes here."
  },
  {
    "title": "Theur Chintamani",
    "description":
      "Theur Chintamani Temple is associated with Lord Ganesha as the remover of worries. Located near Pune, it is an important and frequently visited temple in the Ashtavinayak circuit."
  },
  {
    "title": "Lenyadri Girijatmaj",
    "description":
      "Lenyadri Girijatmaj Temple is uniquely situated inside rock-cut Buddhist caves in the hills. It is the only Ashtavinayak temple located inside a mountain cave structure."
  },
  {
    "title": "Ozar Vighnahar",
    "description":
      "Ozar Vighnahar Temple is a beautiful riverside temple known for its grand architecture and peaceful surroundings. It is one of the most important stops in the Ashtavinayak pilgrimage."
  },
  {
    "title": "Ranjangaon Mahaganpati",
    "description":
      "Ranjangaon Mahaganpati is the final temple in the Ashtavinayak circuit and is considered very powerful spiritually. It is a major pilgrimage destination for devotees completing the yatra."
  },
  {
    "title": "Bhima River Scenic Route",
    "description":
      "The Ashtavinayak route from Pune passes through rural Maharashtra landscapes, river valleys, temples, and peaceful villages, offering a spiritually enriching and scenic road journey."
  },
  {
    "title": "Temple Circuit Experience",
    "description":
      "The Ashtavinayak Darshan journey covers all eight sacred Ganpati temples in a traditional sequence, providing a complete spiritual experience filled with devotion, history, and cultural heritage of Maharashtra."
  }
],



services: [
  {
    name: "Pune Ashtavinayak Cab",
    description: "Pune Ashtavinayak cab service provides reliable transportation for devotees and travelers planning visits to the famous Ashtavinayak temples across Maharashtra. Comfortable vehicles with experienced drivers ensure smooth highway travel for families, pilgrims, and tourists. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different pilgrimage travel requirements. Flexible booking options allow convenient Ashtavinayak cab reservations."
  },
  {
    name: "Ashtavinayak Darshan Cab Pune",
    description: "Ashtavinayak Darshan cab Pune service offers dependable transportation for temple tours covering the sacred Ashtavinayak pilgrimage circuit with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for religious tourism, family trips, and group darshan tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ashtavinayak Darshan cab reservations."
  },
  {
    name: "Pune to Ashtavinayak Taxi",
    description: "Pune to Ashtavinayak taxi service provides comfortable transportation for devotees visiting the renowned Ganpati temples of the Ashtavinayak Yatra circuit. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys across temple routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day and multi-day pilgrimage travel requirements. Flexible booking options allow convenient Ashtavinayak taxi reservations."
  },
  {
    name: "Ashtavinayak Yatra Cab Pune",
    description: "Ashtavinayak Yatra cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for complete temple pilgrimage tours from Pune. Vehicles provide smooth highway travel suitable for religious tourism, family darshan trips, and senior citizen travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy Ashtavinayak Yatra cab reservations."
  },
  {
    name: "Pune Temple Tour Ashtavinayak",
    description: "Pune temple tour Ashtavinayak service provides dependable transportation solutions for passengers traveling to sacred Ganpati temples and pilgrimage destinations from Pune. Vehicles are suitable for long-distance temple travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for spiritual travel, darshan tours, and temple visits. Flexible booking options allow convenient temple tour cab reservations."
  },
  {
    name: "Best Ashtavinayak Cab Pune",
    description: "Best Ashtavinayak cab Pune service provides transparent and reliable transportation for devotees planning comfortable Ashtavinayak temple tours from Pune. Travelers can enjoy peaceful journeys with experienced drivers familiar with temple routes and pilgrimage destinations. Comfortable vehicles ensure smooth highway travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ashtavinayak cab reservations."
  },
  {
    name: "SUV Ashtavinayak Cab",
    description: "SUV Ashtavinayak cab service provides economical and spacious transportation for families and groups planning Ashtavinayak temple tours from Pune. SUV vehicles ensure smooth highway travel suitable for pilgrimage tourism, family darshan trips, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient SUV pilgrimage cab reservations."
  },
  {
    name: "Innova Ashtavinayak Cab",
    description: "Innova Ashtavinayak cab service offers convenient premium SUV transportation for passengers planning comfortable temple darshan tours from Pune. Innova vehicles provide spacious seating, smooth ride quality, and luggage space suitable for long-distance religious travel. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova Ashtavinayak cab reservations."
  },
  {
    name: "Sedan Ashtavinayak Taxi",
    description: "Sedan Ashtavinayak taxi service allows passengers to reserve comfortable and economical transportation for visiting the Ashtavinayak temples from Pune. Sedan vehicles provide smooth highway travel with comfortable seating suitable for couples, solo travelers, and small families. Professional drivers ensure safe driving and punctual pickup services throughout the temple tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow affordable sedan taxi reservations."
  },
  {
    name: "Pune Pilgrimage Ashtavinayak Cab",
    description: "Pune pilgrimage Ashtavinayak cab service provides affordable transportation for devotees planning religious journeys and temple visits from Pune. Vehicles ensure reliable highway travel suitable for spiritual tourism, pilgrimage tours, and family darshan trips. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient pilgrimage cab reservations."
  },
  {
    name: "Ashtavinayak Darshan Booking Pune",
    description: "Ashtavinayak Darshan booking Pune service offers premium transportation with comfortable vehicles and professional chauffeurs for complete Ganpati temple tours. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for religious tourism and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient temple darshan booking reservations."
  },
  {
    name: "One Day Ashtavinayak Cab",
    description: "One day Ashtavinayak cab service provides comfortable transportation for devotees planning same-day temple darshan tours from Pune. Vehicles ensure smooth and safe highway travel suitable for religious tourism, family travel, and spiritual visits. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-day Ashtavinayak cab reservations."
  },
  {
    name: "Religious Tour Cab Pune Ashtavinayak",
    description: "Religious tour cab Pune Ashtavinayak service provides dependable transportation for passengers planning spiritual and temple tours from Pune. Comfortable vehicles ensure smooth highway travel suitable for pilgrimage tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient religious tour cab reservations."
  },
  {
    name: "Ashtavinayak Travel Cab Pune",
    description: "Ashtavinayak travel cab Pune service provides reliable transportation for travelers and devotees planning temple tours and spiritual journeys across the Ashtavinayak circuit. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, senior citizens, and pilgrimage groups. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient travel cab reservations."
  },
  {
    name: "Temple Yatra Cab Pune",
    description: "Temple Yatra cab Pune service offers comfortable transportation for passengers planning religious tours and temple visits from Pune to major pilgrimage destinations. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for spiritual tourism, temple darshan, and family pilgrimage travel. Flexible booking options allow convenient temple yatra cab reservations."
  }
],

tableData: [
  ["Pune Ashtavinayak Cab", "Ashtavinayak Darshan Cab Pune"],
  ["Pune to Ashtavinayak Taxi", "Ashtavinayak Yatra Cab Pune"],
  ["Pune Temple Tour Ashtavinayak", "Best Ashtavinayak Cab Pune"],
  ["SUV Ashtavinayak Cab", "Innova Ashtavinayak Cab"],
  ["Sedan Ashtavinayak Taxi", "Pune Pilgrimage Ashtavinayak Cab"],
  ["Ashtavinayak Darshan Booking Pune", "One Day Ashtavinayak Cab"],
  ["Religious Tour Cab Pune Ashtavinayak", "Ashtavinayak Travel Cab Pune"],
  ["Temple Yatra Cab Pune", "Pune Ashtavinayak Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Ashtavinayak Darshan Cab from Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Ashtavinayak Darshan cab service from Pune with professional drivers, comfortable vehicles, and well-planned routes for smooth pilgrimage journeys."
      },
      {
        WhyChooseheading: "Affordable Ashtavinayak Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Ashtavinayak Darshan cab pricing with transparent fare details and no hidden charges. Customers receive complete package information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Temple Tour Cab Availability",
        WhyChoosedescription: "Our Ashtavinayak Darshan cab service from Pune operates 24 hours a day for temple visits, family pilgrimage tours, group travel, and customized religious travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences throughout the complete Ashtavinayak Darshan journey."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-day Ashtavinayak Darshan tours, multi-day temple packages, round-trip bookings, and customized pilgrimage travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, pilgrims, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with all eight Ashtavinayak temple routes and ensure safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Ashtavinayak Darshan cab service from Pune?", answer: "Ashtavinayak Darshan cab service from Pune provides comfortable taxi transportation for visiting all eight famous Ganpati temples in Maharashtra." },
    { question: "Is Ashtavinayak Darshan cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Ashtavinayak Darshan cab service from Pune." },
    { question: "Which vehicles are available for Ashtavinayak Darshan travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-day Ashtavinayak Darshan tour?", answer: "Yes, customers can book one-day as well as multi-day Ashtavinayak Darshan taxi packages." },
    { question: "Do you provide customized temple tour packages?", answer: "Yes, Shivai Travels provides customized pilgrimage and temple travel packages according to customer requirements." },
    { question: "Are all Ashtavinayak Darshan taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Ashtavinayak Darshan cab service online?", answer: "Yes, customers can easily book Ashtavinayak Darshan cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Ashtavinayak Darshan cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Ashtavinayak Darshan cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Vinay Patil",
      feedback:
        "Booked Ashtavinayak Darshan cab service from Pune with Shivai Travels. Comfortable vehicle, smooth temple tour, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Ashtavinayak Darshan taxi service. Affordable pricing, clean cab, and wonderful pilgrimage travel experience.",
      rating: 5
    }
  ];












  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Cab from Pune",
  "image": "https://shivaitravels.com/assets/images/ashtavinayak-darshan-cab.jpg",
  "description": "Book Ashtavinayak Darshan cab from Pune for a comfortable pilgrimage tour covering all eight Ganpati temples. Shivai Travels offers one-day and multi-day yatra packages with sedan, SUV, Innova, and luxury cab options available 24x7 for religious travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/ashtavinayak-darshan-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Ashtavinayak Darshan Cab from Pune | Temple Yatra Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Ashtavinayak Darshan cab from Pune for a complete pilgrimage tour. Affordable one-day and multi-day packages with sedan, SUV, Innova, and luxury cabs available 24x7 for all eight Ganpati temple visits."
  />

  <meta
    name="keywords"
    content="pune ashtavinayak cab, ashtavinayak darshan cab pune, pune to ashtavinayak taxi, ashtavinayak yatra cab pune, pune temple tour ashtavinayak, best ashtavinayak cab pune, suv ashtavinayak cab, innova ashtavinayak cab, sedan ashtavinayak taxi, pune pilgrimage ashtavinayak cab, ashtavinayak darshan booking pune, one day ashtavinayak cab, religious tour cab pune ashtavinayak, ashtavinayak travel cab pune, temple yatra cab pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ashtavinayakdarshancab;